import React from 'react';
import { string, shape, arrayOf, func } from 'prop-types';
import Icon from 'components/icon';

export default class KeywordFilter extends React.Component {
    constructor(props) {
        super(props);

        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.submitKeyword = this.submitKeyword.bind(this);
        this.state = { keywordSearch: this.props.keyword };
    }

    shouldComponentUpdate(newProps, newState) {
        return (
            newProps.keyword !== this.props.keyword ||
            this.state.keywordSearch !== newState.keywordSearch
        );
    }

    /* eslint-disable-next-line camelcase */
    UNSAFE_componentWillReceiveProps(newProps) {
        if (newProps.keyword !== this.props.keyword) {
            this.setState({ keywordSearch: newProps.keyword });
        }
    }

    submitKeyword(e) {
        e.preventDefault();
        this.props.updateKeyword.call(
            this,
            e,
            this.props.filter,
            this.state.keywordSearch
        );
    }

    handleKeyPress(e) {
        // Pass the input value back to the update call back function when enter is pressed
        if (e.key === 'Enter') {
            e.preventDefault(); // stops kentico page form from submitting
            this.submitKeyword(e);
        }
    }

    handleChange(e) {
        this.setState({ keywordSearch: e.target.value });
    }

    render() {
        const inputId = `keyword-search-${this.props.filter.code}`;

        return (
            <div
                className={`keyword-filter input-wrapper ${this.props.classModifier}`}
            >
                <div className="FieldLabel hidden">
                    <label htmlFor={inputId} className="EditingFormLabel">
                        Keyword Search
                    </label>
                </div>
                <div className="EditingFormValueCell">
                    <div className="EditingFormControlNestedControl editing-form-control-nested-control">
                        <input
                            type="text"
                            maxLength="250"
                            id={inputId}
                            value={this.state.keywordSearch}
                            onChange={this.handleChange}
                            onKeyPress={this.handleKeyPress}
                            placeholder={this.props.placeholderText}
                            className="form-control"
                        />
                        <button
                            className="search-button"
                            value={this.state.keywordSearch}
                            onClick={this.submitKeyword}
                            onKeyPress={this.handleKeyPress}
                        >
                            <Icon glyph="search" />
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

KeywordFilter.propTypes = {
    /* eslint-disable react/no-typos */
    // The disable is needed until https://github.com/yannickcr/eslint-plugin-react/issues/1389 is resolved
    keyword: string,
    filter: shape({
        code: string.isRequired,
        label: string.isRequired,
        values: arrayOf(string)
    }).isRequired,
    placeholderText: string,
    updateKeyword: func.isRequired,
    classModifier: string
    /* eslint-enable react/no-typos */
};

KeywordFilter.defaultProps = {
    keyword: '',
    placeholderText: '',
    classModifier: ''
};
